const initialState = {
    settleList: [],
};

const settlements = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_SETTLEMENTS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default settlements;
